/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./doorCard.vue?vue&type=template&id=5e105cf9&scoped=true"
import script from "./doorCard.vue?vue&type=script&lang=js"
export * from "./doorCard.vue?vue&type=script&lang=js"
import style0 from "./doorCard.vue?vue&type=style&index=0&id=5e105cf9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e105cf9",
  null
  
)

export default component.exports